import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AnimatedView from "../../../../components";
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from "../../../../services/fetchTools";
import { withRouter } from "react-router";
import "./viewfixturescreen.css";
import moment from "moment";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
var Spinner = require("react-spinkit");

import {
  colors,
  btn,
  spinner as spinnerStyle,
} from "../../../../style/common/partnerStyle";

import { SAMPLE_MATCH_JSON } from "./constants";
import { IconArrowLeft } from "./icons";
import CreateFixtureForm from "./CreateFixtureForm";
import { KnockoutLeaderBoardPopup, LeaderBoardPopup } from "./LeaderBoardPopup";
import { ScoreBoardMobile, ScoreBoardDesktop } from "./ScoreboardDialogs";
import FixtureRound from "./FixtureRound";

// ── Match highlight helper ────────────────────────────────────────────────────
// Returns { bg, border, label } describing the visual state of a match card.
// Pass this into FixtureRound as a prop (getMatchHighlight) so each match card
// can apply it to its container style.
//
// States (in priority order):
//   needs-score  amber  — session_start is in the past but no scores yet
//   unscored     slate  — upcoming match, no scores yet
//   draw         blue   — scores saved, no winner on either side
//   scored       green  — scores saved, a winner is set
//
// NOTE: session_start is stored as "DD/MM/YYYY hh:mm A" (e.g. "07/04/2026 03:00 PM").
// new Date() can't parse that format reliably across browsers, so we parse manually.
export function getMatchHighlight(match) {
  const t1 = match.team_one;
  const t2 = match.team_two;

  // ── 1. Determine whether scores exist ──────────────────────────────────────
  const s1raw = match.team1_scores && match.team1_scores[0];
  const s2raw = match.team2_scores && match.team2_scores[0];
  const hasScore =
    s1raw !== undefined && s1raw !== null && s1raw !== "" &&
    s2raw !== undefined && s2raw !== null && s2raw !== "";

  // ── 2. Parse session_start manually ("DD/MM/YYYY hh:mm A") ────────────────
  let isPast = false;
  if (match.session_start) {
    try {
      const parts = match.session_start.trim().split(" ");
      // parts: ["07/04/2026", "03:00", "PM"]
      const dateParts = parts[0].split("/");
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // JS months are 0-indexed
      const year = parseInt(dateParts[2], 10);
      let hours = 0, minutes = 0;
      if (parts.length >= 3) {
        const timeParts = parts[1].split(":");
        hours = parseInt(timeParts[0], 10);
        minutes = parseInt(timeParts[1], 10);
        const ampm = parts[2].toUpperCase();
        if (ampm === "PM" && hours !== 12) hours += 12;
        if (ampm === "AM" && hours === 12) hours = 0;
      }
      const sessionDate = new Date(year, month, day, hours, minutes, 0);
      isPast = !isNaN(sessionDate.getTime()) && sessionDate < new Date();
    } catch (_) { /* ignore — treat as not past */ }
  }

  // ── 3. Return highlight based on state ────────────────────────────────────
  if (!hasScore && isPast) {
    // Past match, no score yet — needs attention
    return { bg: "#fff7ed", border: "#f59e0b", label: "needs-score" };
  }
  if (!hasScore) {
    // Upcoming / unscored
    return { bg: "#f8fafc", border: "#cbd5e1", label: "unscored" };
  }

  const t1wins = t1 && t1.winner === true;
  const t2wins = t2 && t2.winner === true;
  const isDraw = !t1wins && !t2wins;

  if (isDraw) {
    // Scores present, no winner flag — draw
    return { bg: "#eff6ff", border: "#3b82f6", label: "draw" };
  }

  // Scores present + winner flag set
  return { bg: "#f0fdf4", border: "#22c55e", label: "scored" };
}

class viewFixtureScreen extends PureComponent {
  // Add a new court to the courts state
  handleAddCourt = (courtName) => {
    if (!courtName) return;
    // Use the typed value as both id and name for the new court
    const newCourt = { id: courtName, name: courtName };
    this.setState((prev) => ({
      courts: [...prev.courts, newCourt],
    }));
  };
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      competition_id: this.props.match.params.id,
      addFixtureView: false,
      fixture_created: false,
      openCreateFixturesPopup: false,
      openKnockoutFixturesPopup: false,
      tournament_data: "",
      venues: [],
      buddies: [],
      team_list: [],
      team_count: 0,
      selected_rows: [],
      new_selected_rows: [],
      courts: [],
      zones: [],
      match_details: {
        tournament_id: "",
        buddy_ids: [],
        start_time: "",
        end_time: "",
        match_duration: "",
        venue: [],
        venues: [],
        available_courts: 1,
        selected_format: "",
        selected_venue: "",
        is_loading: true,
        competition_id: this.props.match.params.id,
        courts: [],
        leader_board: [],
      },
      fixtures: [],
      submit_button_pressed: false,
      sets: [0, 0, 0],
      openLeaderBoarderPopup: false,
      openKnockLeaderBoardPopup: false,
      leader_board: [],
      leaderboard_loading: false,
      selected_group: 0,
      makeSelectOption: false,
      checkedbox: false,
      knockout_matches_created: false,
      openScoreBoard: false,
      leftOpen: false,
      rightOpen: false,
      selected_event: "",
      selectedEvent: "",
      openPlayerList: false,
      teamSide: "",
      eventActionMatch: "",
      footballMatchLeftTeamScore: {},
      footballMatchRightTeamScore: {},
      competition_game: "",
      game_events: [],
      venue: [],
      selected_zone: 0,
      selected_indexes: { grp: "", round: "", match: "" },
      cup_shield_bowl_type: 'cup',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchBuddy = this.searchBuddy.bind(this);
    this.handleFixtureCourt = this.handleFixtureCourt.bind(this);
    this.handleTeamChange = this.handleTeamChange.bind(this);
    this.addRound = this.addRound.bind(this);
    this.addMatch = this.addMatch.bind(this);
    this.onClickCreate = this.onClickCreate.bind(this);
    this.handleModel = this.handleModel.bind(this);
    this.setDefautmatchData = this.setDefautmatchData.bind(this);
    this.getRandomColor = this.getRandomColor.bind(this);
    this.createImageFromInitials = this.createImageFromInitials.bind(this);
    this.createCupShieldBowlTournament = this.createCupShieldBowlTournament.bind(this);
  }

  componentDidMount() {
    this.getTournamentTeamDetails();
    this.getTeamList();
    this.getCompetitionFixtures();
    this.getStructureDetails();
  }

  getStructureDetails() {
    const url = `${getLocationOrigin()}/tournament/get_structure_details/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      competitions_id: this.state.competition_id,
    });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => { console.log(error); alert(error.message); })
      .then((data) =>
        this.setState({
          chosen_format: data.structure_list[0].game_format,
          zones: data.structure_list[0].match_zones,
        }),
      );
  }

  getCompetitionFixtures() {
    const url = `${getLocationOrigin()}/tournament/get_competition_fixtures/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      competition_id: this.state.competition_id,
    });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => { console.log(error); alert(error.message); })
      .then((data) => {
        let fix_data = JSON.parse(JSON.stringify(data.fixtures));
        for (let grp = 0; grp < fix_data.length; grp++) {
          fix_data[grp].group_round_robin = fix_data[grp].group_round_robin.filter(
            (r) => r.matches && r.matches.length > 0
          );

          for (let rbn = 0; rbn < fix_data[grp].group_round_robin.length; rbn++) {
            for (let fxtr = 0; fxtr < fix_data[grp].group_round_robin[rbn].matches.length; fxtr++) {
              const match = fix_data[grp].group_round_robin[rbn].matches[fxtr];
              match["have_changes"] = false;
              match["found_clash"] = false;
              if (!match["venue"] && match["court"] && match["court"].id) {
                match["venue"] = String(match["court"].id);
              } else if (
                match["venue"] &&
                typeof match["venue"] === "object" &&
                match["venue"].id
              ) {
                match["venue"] = String(match["venue"].id);
              }
            }
          }
        }
        this.setState(
          {
            fixtures: fix_data,
            groups: data.groups,
            is_loading: false,
            courts: data.courts,
            venues: data.venues || [],
            knockout_matches_created: data.knockout_matches_created,
            tournament_data: data.categories ? { categories: data.categories } : this.state.tournament_data,
          },
          () => {
            if (data.fixtures.length == 0 && data.message) {
              alert(data.message);
              this.props.history.goBack();
            }
          },
        );
      });
  }

  createCompetitionFixtures() {
    if (
      this.state.match_details.start_time &&
      this.state.match_details.match_duration &&
      this.state.match_details.selected_format
    ) {
      const url = `${getLocationOrigin()}/tournament/create_competition_fixtures/`;
      const options = { ...defaultOptions };
      options["method"] = "post";
      options["headers"] = { "content-type": "application/json" };
      options["body"] = JSON.stringify({
        competition_id: this.state.competition_id,
        match_details: this.state.match_details,
      });
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({ submit_button_pressed: false });
        })
        .then((data) => {
          this.setState({ submit_button_pressed: false });
          alert(data.message);
          window.location.reload();
        });
    } else {
      this.setState({ submit_button_pressed: false });
      alert("Please fill required fields !!");
    }
  }

  onClickCreate(event) {
    if (this.state.knockout_matches_created == true) {
      alert("Knockout matches already created!\nDelete knockout matches to create new!!");
    } else {
      if (confirm("You cannot edit league match after knockout fixture creation, \nAre you sure !!?") == true) {
        this.setState({ knockout_matches_created: true });
        this.createKnockoutMatches();
      }
    }
  }

  createKnockoutMatches() {
    if (
      this.state.chosen_format == 30 ||
      this.state.chosen_format == 80 ||
      this.state.chosen_format == 10
    ) {
      var selected_rows = this.state.selected_rows
        .filter((x) => x != undefined)
        .map((x) => x.team_id);
      var arr_length = selected_rows.length;
      this.setState({ team_count: arr_length }, () => {
        var new_selected_one = Object.assign({}, this.state.match_details);
        if (new_selected_one["start_time"] == "") new_selected_one["start_time"] = "10:00";
        if (new_selected_one["match_duration"] == "") new_selected_one["match_duration"] = 10;
        new_selected_one["end_time"] = "20:00";
        new_selected_one["available_courts"] = 1;
        new_selected_one["selected_venue"] = "";
        this.setState({ match_details: new_selected_one }, () => {
          const url = `${getLocationOrigin()}/tournament/create_knockout_matches/`;
          const options = { ...defaultOptions };
          options["method"] = "post";
          options["headers"] = { "content-type": "application/json" };
          options["body"] = JSON.stringify({
            competition_id: this.state.competition_id,
            qualified_players_no: arr_length,
            match_duration: this.state.match_details.match_duration,
            start_time: this.state.match_details.start_time,
            venue: this.state.match_details.selected_venue,
            buddy_ids: this.state.match_details.buddy_ids,
            qualified_team_ids: selected_rows,
            chosen_format: this.state.chosen_format,
            zone: this.state.selected_zone,
          });
          return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .catch((error) => { console.log(error); alert(error.message); })
            .then((data) => {
              if (data && data.message) alert(data.message);
              window.location.reload();
            });
        });
      });
    } else {
      var selected_rows = this.state.selected_rows
        .filter((x) => x != undefined)
        .map((x) => x.team_id);
      var arr_length = selected_rows.length;
      this.setState({ submit_button_pressed: true, team_count: arr_length }, () => {
        const url = `${getLocationOrigin()}/tournament/create_knockout_matches/`;
        var new_selected_one = Object.assign({}, this.state.match_details);
        if (new_selected_one["match_duration"] == "") new_selected_one["match_duration"] = 10;
        this.setState({ match_details: new_selected_one }, () => {
          const options = { ...defaultOptions };
          options["method"] = "post";
          options["headers"] = { "content-type": "application/json" };
          options["body"] = JSON.stringify({
            competition_id: this.state.competition_id,
            qualified_players_no: arr_length,
            match_duration: this.state.match_details.match_duration,
            start_time: this.state.match_details.start_time,
            venue: this.state.match_details.selected_venue,
            buddy_ids: this.state.match_details.buddy_ids,
            qualified_team_ids: selected_rows,
            chosen_format: this.state.chosen_format,
            zone: this.state.selected_zone,
          });
          return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .catch((error) => {
              console.log(error);
              alert(error.message);
              this.setState({ submit_button_pressed: false });
            })
            .then((data) => {
              if (data && data.message) alert(data.message);
              this.setState({ submit_button_pressed: false });
              window.location.reload();
            });
        });
      });
    }
  }

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ search: mobile_no });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => this.setState({ buddy_search_list: data.results, search: true }))
      .catch((error) => { console.log(error); alert(error.message); });
  }

  searchBuddy() {
    this.state.match_details.mobile_no
      ? this.getSearchList(this.state.match_details.mobile_no)
      : alert("Search cannot be blank");
  }

  setSearch(name, mobile, id) {
    var new_selected_one = Object.assign({}, this.state.match_details);
    var buddies = Object.assign([], this.state.buddies);
    buddies.push({
      id: id,
      name: name,
      photo: "http://www.sporthood.in/assets/img/avatar.png",
    });
    new_selected_one["buddy_ids"].push(id);
    this.setState({ match_details: new_selected_one, search: false, buddies: buddies });
  }

  getTournamentTeamDetails() {
    const url = `${getLocationOrigin()}/eagleeye/get_match_input_for_competition/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ competition_id: this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        if (data.venues && data.venues.length > 0) {
          var new_selected_one = Object.assign({}, this.state.match_details);
          new_selected_one["selected_venue"] = data.venues[0].id;
          this.setState({ match_details: new_selected_one });
        }
        this.setState({
          venue: data.venues,
          competition_game: data.game,
          game_events: data.game_events,
        });
      })
      .catch((error) => error);
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.match_details);
    new_selected_one[name] = event.target.value;
    this.setState({ match_details: new_selected_one });
  }

  onStartTimeChange(options) {
    var new_selected_one = Object.assign({}, this.state.match_details);
    new_selected_one["start_time"] = options["format24"];
    this.setState({ match_details: new_selected_one });
  }

  openCreateFixturesPopup() {
    this.setState({ openCreateFixturesPopup: true });
  }

  handleSubmit(event) {
    if (confirm("You cannot add team after create fixtures, \nAre you sure !!?") == true) {
      this.confirmCreateFixture();
    }
  }

  confirmCreateFixture() {
    this.setState({
      submit_button_pressed: true,
      chosen_format: this.state.match_details.selected_format,
    });
    event.preventDefault();
    if (this.state.match_details.selected_format == 20) {
      this.setState({ submit_button_pressed: true });
      this.createKnockoutMatches();
    } else {
      this.createCompetitionFixtures();
    }
  }

  handleRequestDelete = (key) => {
    var buddies = Object.assign([], this.state.buddies);
    const chipToDelete = buddies.findIndex((chip) => chip.id == key);
    buddies.splice(chipToDelete, 1);
    var new_selected_one = Object.assign({}, this.state.match_details);
    const id_index = new_selected_one["buddy_ids"].findIndex((buddy_id) => buddy_id == key);
    new_selected_one["buddy_ids"].splice(id_index, 1);
    this.setState({ buddies: buddies, match_details: new_selected_one });
  };

  // getTournamentDetails() removed — categories now come from getCompetitionFixtures()

  getTeamList() {
    const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ competition_id: this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => this.setState({ team_list: data.teamlist, team_count: data.team_count }))
      .catch((error) => { console.log(error); alert(error.message); });
  }

  handleFixtureCourt(e, grp, round, match) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    const matchObj = fixtures[grp].group_round_robin[round].matches[match];
    matchObj["court"] = String(e.target.value);
    matchObj["have_changes"] = true;
    this.setState({ fixtures: fixtures });
  }

  handleTeamChange(e, grp, round, match, team_position) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    const selectedTeam = this.state.team_list.find(
      (t) => String(t.id) === String(e.target.value),
    );
    const selectedTeamName = (selectedTeam && (selectedTeam.team.name || selectedTeam.name)) || "";
    const selectedTeamLogo = (selectedTeam && (selectedTeam.team.logo || selectedTeam.logo)) || "";

    if (team_position == "team_one") {
      fixtures[grp].group_round_robin[round].matches[match]["team_one"] = {
        id: String(e.target.value),
        name: selectedTeamName,
        logo: selectedTeamLogo,
      };
    } else {
      fixtures[grp].group_round_robin[round].matches[match]["team_two"] = {
        id: String(e.target.value),
        name: selectedTeamName,
        logo: selectedTeamLogo,
      };
    }
    fixtures[grp].group_round_robin[round].matches[match]["have_changes"] = true;
    this.setState({ fixtures: fixtures });
  }

  handleDateTimePicker(date_time, grp, round, match, part) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    const existing = fixtures[grp].group_round_robin[round].matches[match]["session_start"];

    let datePart = existing ? existing.split(" ")[0] : moment().format("DD/MM/YYYY");
    let timePart = existing ? existing.split(" ").slice(1).join(" ") : "12:00 AM";

    if (part === "date") {
      datePart = moment(date_time.toDate()).format("DD/MM/YYYY");
    } else {
      timePart = moment(date_time.toDate()).format("hh:mm A");
    }

    fixtures[grp].group_round_robin[round].matches[match]["session_start"] =
      datePart + " " + timePart;
    fixtures[grp].group_round_robin[round].matches[match]["have_changes"] = true;
    this.setState({ fixtures: fixtures });
  }

  handleKnockout(event, team) {
    var rows = this.state.selected_rows.slice();
    var checked = event.target.checked;
    if (!checked) {
      var remove_team = rows.findIndex((x) => String(x.team_id) === String(team.team_id));
      if (remove_team > -1) rows.splice(remove_team, 1);
    } else {
      var already = rows.some((x) => String(x.team_id) === String(team.team_id));
      if (!already) rows.push(team);
    }
    this.setState({ selected_rows: rows });
  }

  createCupShieldBowlTournament() {
    var self = this;
    var team_ids = this.state.selected_rows.map(function (x) { return x.team_id; });
    var payload = {
      competition_id: this.state.competition_id,
      tournament_type: this.state.cup_shield_bowl_type,
      team_ids: team_ids,
    };
    const url = getLocationOrigin() + '/tournament/create_cup_shield_bowl/';
    const options = Object.assign({}, defaultOptions);
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify(payload);
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(function (error) { console.log(error); alert(error.message); })
      .then(function (data) {
        if (!data) return;
        alert(data.message);
        window.location.reload();
      });
  }

  saveMatchScore(match_id, grp, round, match, t1, t2) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    const matchObj = fixtures[grp].group_round_robin[round].matches[match];
    matchObj.team1_scores = t1 !== "" && t1 !== undefined ? [t1] : [];
    matchObj.team2_scores = t2 !== "" && t2 !== undefined ? [t2] : [];
    matchObj.have_changes = true;
    this.setState({ fixtures }, () => {
      this.updateMatch(match_id, grp, round, match);
    });
  }

  updateMatch(match_id, grp, round, match) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_match = fixtures[grp].group_round_robin[round].matches[match];
    if (selected_match.team_one.id == undefined) { alert("Please select team one"); return false; }
    if (selected_match.team_two.id == undefined) { alert("Please select team two"); return false; }
    if (selected_match.team_one.id == selected_match.team_two.id) { alert("Teams cannot be same"); return false; }
    if (selected_match.court == undefined) { alert("Please select court"); return false; }
    if (selected_match.session_start == null) { alert("Please select match time"); return false; }

    this.setState({ submit_button_pressed: true });
    let fetch_break = false;
    let team1_score_arr_len = selected_match.team1_scores.length;
    let team2_score_arr_len = selected_match.team2_scores.length;
    let max_len_score_arr = team1_score_arr_len;
    let max_score_arr = selected_match.team1_scores;
    let min_len_score_arr = team2_score_arr_len;
    if (team2_score_arr_len > team1_score_arr_len) {
      max_len_score_arr = team2_score_arr_len;
      min_len_score_arr = team1_score_arr_len;
      max_score_arr = selected_match.team2_scores;
    }
    if (selected_match.team1_scores.length != selected_match.team2_scores.length) {
      for (let i = min_len_score_arr; i < max_len_score_arr; i++) {
        if (max_score_arr[i] != "") {
          fetch_break = true;
        } else {
          max_score_arr.splice(i, 1);
          i--;
          max_len_score_arr--;
        }
      }
    }
    for (let i = 0; i < min_len_score_arr; i++) {
      if (
        (selected_match.team1_scores[i] == "" && selected_match.team2_scores[i] != "") ||
        (selected_match.team1_scores[i] != "" && selected_match.team2_scores[i] == "")
      ) {
        fetch_break = true;
      }
    }
    this.setState({ fixtures: fixtures }, () => {
      this.updateMatchConfirm(match_id, grp, round, match, fetch_break);
    });
  }

  updateMatchConfirm(match_id, grp, round, match, fetch_break) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_match = fixtures[grp].group_round_robin[round].matches[match];

    if ((fetch_break == false && this.state.competition_game.id != 1) || this.state.competition_game.id == 1) {
      const url = `${getLocationOrigin()}/tournament/update_competition_match/`;
      const options = { ...defaultOptions };
      options["method"] = "post";
      options["headers"] = { "content-type": "application/json" };
      options["body"] = JSON.stringify({ match_details: selected_match });
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch((error) => {
          console.log(error);
          alert(error.message);
          this.setState({ submit_button_pressed: false });
        })
        .then((data) => {
          if (!data) return;
          this.setState((prevState) => {
            let fresh = JSON.parse(JSON.stringify(prevState.fixtures));
            let m = fresh[grp].group_round_robin[round].matches[match];
            m.team1_scores = selected_match.team1_scores;
            m.team2_scores = selected_match.team2_scores;

            if (String(m.team_one.id) === String(data.winner)) {
              m.team_one.winner = true;
              m.team_two.winner = false;
            } else if (String(m.team_two.id) === String(data.winner)) {
              m.team_two.winner = true;
              m.team_one.winner = false;
            } else {
              m.team_one.winner = false;
              m.team_two.winner = false;
            }

            if (data.success === true) m.have_changes = false;
            if (data.match_id) m.id = data.match_id;

            return { fixtures: fresh, submit_button_pressed: false };
          }, () => { alert(data.message); });
        });
    } else {
      alert("Please enter scores for each team !!");
      this.setState({ submit_button_pressed: false });
    }
  }

  addRound(e, grp) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    const newRoundNo = fixtures[grp].group_round_robin.length + 1;
    fixtures[grp].group_round_robin.push({
      round_no: newRoundNo,
      matches: [],
      _isNew: true,
    });
    this.setState({ fixtures: fixtures });
  }

  addMatch(e, grp, round) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let roundObj = fixtures[grp].group_round_robin[round];
    let matchJson = JSON.parse(JSON.stringify(SAMPLE_MATCH_JSON));
    matchJson["competition_id"] = this.state.competition_id;
    matchJson["leaugue_round"] = roundObj.round_no;
    fixtures[grp].group_round_robin[round].matches.push(matchJson);
    this.setState({ fixtures: fixtures });
  }

  removeUnsavedMatch(grp, round, match) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[grp].group_round_robin[round].matches.splice(match, 1);
    this.setState({ fixtures });
  }

  removeUnsavedRound(grp, round) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    fixtures[grp].group_round_robin.splice(round, 1);
    this.setState({ fixtures });
  }

  saveNewMatch(grp, round, match) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_match = JSON.parse(
      JSON.stringify(fixtures[grp].group_round_robin[round].matches[match]),
    );

    if (!selected_match.court) { alert("Please select a court."); return; }
    if (!selected_match.team_one || !selected_match.team_one.id) { alert("Please select team one."); return; }
    if (!selected_match.team_two || !selected_match.team_two.id) { alert("Please select team two."); return; }
    if (!selected_match.session_start) { alert("Please select match date and time."); return; }

    const url = `${getLocationOrigin()}/tournament/add_competition_match/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      competition_id: this.state.competition_id,
      match_details: selected_match,
    });

    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => { console.log(error); alert(error.message); })
      .then((data) => {
        if (data && data.match) {
          const teamOneFromResponse = data.match.team_one || selected_match.team_one || {};
          const teamTwoFromResponse = data.match.team_two || selected_match.team_two || {};

          const resolveTeamMeta = (teamObj, teamId) => {
            const fromState = this.state.team_list.find(
              (t) => String(t.id) === String(teamObj.id || teamId),
            );
            const fromStateTeamName = fromState ? (fromState.team ? fromState.team.name : fromState.name) : "";
            const fromStateTeamLogo = fromState ? (fromState.team ? fromState.team.logo : fromState.logo) : "";
            return {
              id: String(teamObj.id || teamId || ""),
              name: teamObj.name || fromStateTeamName || "",
              logo: teamObj.logo || fromStateTeamLogo || "",
            };
          };

          this.setState(
            (prevState) => {
              let fresh_fixtures = JSON.parse(JSON.stringify(prevState.fixtures));
              let savedVenue = selected_match.venue;
              if (data.match.venue) {
                savedVenue = typeof data.match.venue === "object" ? data.match.venue.id : data.match.venue;
              } else if (data.match.court && data.match.court.id) {
                savedVenue = data.match.court.id;
              }
              fresh_fixtures[grp].group_round_robin[round].matches[match] = {
                ...data.match,
                id: data.match.id,
                team_one: resolveTeamMeta(teamOneFromResponse, selected_match.team_one.id),
                team_two: resolveTeamMeta(teamTwoFromResponse, selected_match.team_two.id),
                venue: String(savedVenue || ""),
                court: data.match.court || selected_match.court || {},
                leaugue_round: selected_match.leaugue_round,
                competition_id: selected_match.competition_id,
                have_changes: false,
                found_clash: false,
              };
              return { fixtures: fresh_fixtures };
            },
            () => { alert(data.message); },
          );
        } else {
          alert(data.message);
        }
      });
  }

  saveNewRound(grp, round) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_round = fixtures[grp].group_round_robin[round];
    console.log("TODO: POST new round to backend", selected_round);
  }

  changeScore(e, grp, round, match, set_key) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    if (e.target.id == "team1_scores") {
      if (fixtures[grp].group_round_robin[round].matches[match]["team1_scores"][set_key] != undefined) {
        fixtures[grp].group_round_robin[round].matches[match]["team1_scores"][set_key] = e.target.value;
      } else if (
        (fixtures[grp].group_round_robin[round].matches[match]["team1_scores"].length == 0 && set_key == 0) ||
        fixtures[grp].group_round_robin[round].matches[match]["team1_scores"][set_key - 1] != undefined
      ) {
        fixtures[grp].group_round_robin[round].matches[match]["team1_scores"].push(e.target.value);
      } else {
        alert("Please enter set " + set_key.toString() + " score !!");
      }
    } else if (e.target.id == "team2_scores") {
      if (fixtures[grp].group_round_robin[round].matches[match]["team2_scores"][set_key] != undefined) {
        fixtures[grp].group_round_robin[round].matches[match]["team2_scores"][set_key] = e.target.value;
      } else if (
        (fixtures[grp].group_round_robin[round].matches[match]["team2_scores"].length == 0 && set_key == 0) ||
        fixtures[grp].group_round_robin[round].matches[match]["team2_scores"][set_key - 1] != undefined
      ) {
        fixtures[grp].group_round_robin[round].matches[match]["team2_scores"].push(e.target.value);
      } else {
        alert("Please enter set " + set_key.toString() + " score !!");
      }
    }
    fixtures[grp].group_round_robin[round].matches[match]["have_changes"] = true;
    this.setState({ fixtures: fixtures });
  }

  deleteFixtures() {
    if (confirm("IMPORTANT !!\nAre you sure you want to delete?\nAll fixtures and the scores will be deleted permanently !!") == true) {
      this.confirmDeleteFixtures();
    }
  }

  confirmDeleteFixtures() {
    this.setState({ submit_button_pressed: true });
    const url = `${getLocationOrigin()}/tournament/delete_competition_fixtures/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      competition_id: this.state.competition_id,
      match_type: "league_matches",
    });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        console.log(error);
        alert(error.message);
        this.setState({ submit_button_pressed: false });
      })
      .then((data) => {
        alert(data.message);
        this.setState({ submit_button_pressed: false });
        window.location.reload();
      });
  }

  openPopup(grp, round, match) {
    let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
    let selected_match = fixtures[grp].group_round_robin[round].matches[match];
    if (selected_match.team_one.id == undefined) { alert("Please select team one"); return false; }
    if (selected_match.team_two.id == undefined) { alert("Please select team two"); return false; }
    if (selected_match.team_one.id == selected_match.team_two.id) { alert("Teams cannot be same"); return false; }

    let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
    let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
    footballMatchLeftTeamScore["match_id"] =
      this.state.fixtures[grp].group_round_robin[round].matches[match].id;
    footballMatchRightTeamScore["match_id"] =
      this.state.fixtures[grp].group_round_robin[round].matches[match].id;

    if ((footballMatchLeftTeamScore["match_id"] && footballMatchRightTeamScore["match_id"]) == undefined) {
      alert("Please create Match first");
      return false;
    }

    let tourn_match = this.state.fixtures[grp].group_round_robin[round].matches[match];
    let fixturer_indexes = { grp: grp, round: round, match: match };
    this.setState(
      {
        openScoreBoard: true,
        eventActionMatch: tourn_match,
        footballMatchRightTeamScore: footballMatchRightTeamScore,
        footballMatchLeftTeamScore: footballMatchLeftTeamScore,
        selected_indexes: fixturer_indexes,
        leftOpen: false,
        rightOpen: false,
        selectedEvent: "",
      },
      () => {
        this.setDefautmatchData("left");
        this.setDefautmatchData("right");
      },
    );
  }

  saveZeroZero() {
    var idx = this.state.selected_indexes;
    if (idx.grp === "" || idx.round === "" || idx.match === "") return;
    var match = this.state.fixtures[idx.grp].group_round_robin[idx.round].matches[idx.match];
    this.saveMatchScore(match.id, idx.grp, idx.round, idx.match, 0, 0);
  }

  setDefautmatchData(side) {
    if (side == "left") {
      let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
      footballMatchLeftTeamScore["player_id"] = null;
      footballMatchLeftTeamScore["team_id"] = this.state.eventActionMatch.team_one.id;
      footballMatchLeftTeamScore["event"] = "";
      footballMatchLeftTeamScore["side"] = "left";
      this.setState({ footballMatchLeftTeamScore: footballMatchLeftTeamScore });
    } else if (side == "right") {
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchRightTeamScore["player_id"] = null;
      footballMatchRightTeamScore["team_id"] = this.state.eventActionMatch.team_two.id;
      footballMatchRightTeamScore["event"] = "";
      footballMatchRightTeamScore["side"] = "right";
      this.setState({ footballMatchRightTeamScore: footballMatchRightTeamScore });
    }
  }

  getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var j = 0; j < 6; j++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  createImageFromInitials(size, name, color) {
    let initials = name.substring(0, 1);
    name = initials.toUpperCase();
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.width = canvas.height = size;
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, size, size);
    context.fillStyle = `${color}50`;
    context.fillRect(0, 0, size, size);
    context.fillStyle = color;
    context.textBaseline = "middle";
    context.textAlign = "center";
    context.font = `${size / 2}px Roboto`;
    context.fillText(name, size / 2, size / 2);
    return canvas.toDataURL();
  }

  deleteEventHistory(event_activity_id, side) {
    if (confirm("Are you sure you want delete?") == true) {
      this.confirmDeleteEventHistory(event_activity_id, side);
    }
  }

  confirmDeleteEventHistory(event_activity_id, side) {
    this.setState({ submit_button_pressed: true });
    const url = `${getLocationOrigin()}/tournament/delete_football_event_activity/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ event_activity_id: event_activity_id, team_side: side });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
        let current_fixtures = JSON.parse(JSON.stringify(this.state.eventActionMatch));
        current_fixtures.team1_scores[0] = parseInt(data.team1_scores);
        current_fixtures.team2_scores[0] = parseInt(data.team2_scores);
        current_fixtures.match_events = data.match_events;
        current_fixtures["have_changes"] = true;
        fixtures[this.state.selected_indexes["grp"]].group_round_robin[
          this.state.selected_indexes["round"]
        ].matches[this.state.selected_indexes["match"]] = current_fixtures;
        this.setState({
          eventActionMatch: current_fixtures,
          fixtures: fixtures,
          submit_button_pressed: false,
        });
      })
      .catch((error) => error);
  }

  handleChangePlayer(e, side) {
    if (side == "left") {
      let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
      footballMatchLeftTeamScore["player_id"] = e.target.value;
      footballMatchLeftTeamScore["team_id"] = this.state.eventActionMatch.team_one.id;
      footballMatchLeftTeamScore["event"] = this.state.selectedEvent.id;
      footballMatchLeftTeamScore["side"] = "left";
      this.setState({ footballMatchLeftTeamScore: footballMatchLeftTeamScore });
    } else if (side == "right") {
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchRightTeamScore["player_id"] = e.target.value;
      footballMatchRightTeamScore["team_id"] = this.state.eventActionMatch.team_two.id;
      footballMatchRightTeamScore["event"] = this.state.selectedEvent.id;
      footballMatchRightTeamScore["side"] = "right";
      this.setState({ footballMatchRightTeamScore: footballMatchRightTeamScore });
    }
  }

  handleModel(e, dir) {
    var event = this.state.game_events.filter((x) => x.id == e.target.value)[0];
    this.setState(
      { selectedEvent: event, openPlayerList: true, teamSide: dir },
      () => {
        if (dir == "left") {
          let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
          footballMatchLeftTeamScore["team_id"] = this.state.eventActionMatch.team_one.id;
          footballMatchLeftTeamScore["player_id"] = "";
          footballMatchLeftTeamScore["event"] = this.state.selectedEvent.id;
          footballMatchLeftTeamScore["side"] = "left";
          footballMatchLeftTeamScore["selected_event"] = event.event;
          var leftOpen = event.value == "" ? false : true;
          this.setState({ footballMatchLeftTeamScore: footballMatchLeftTeamScore, leftOpen: leftOpen });
        }
        if (dir == "right") {
          let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
          footballMatchRightTeamScore["player_id"] = "";
          footballMatchRightTeamScore["team_id"] = this.state.eventActionMatch.team_two.id;
          footballMatchRightTeamScore["event"] = this.state.selectedEvent.id;
          footballMatchRightTeamScore["side"] = "right";
          footballMatchRightTeamScore["selected_event"] = event.event;
          var rightOpen = event.value == "" ? false : true;
          this.setState({ footballMatchRightTeamScore: footballMatchRightTeamScore, rightOpen: rightOpen });
        }
      },
    );
  }

  changeEventTime(e, side) {
    if (side == "left") {
      let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
      footballMatchLeftTeamScore["event_time"] = e.target.value;
      this.setState({ footballMatchLeftTeamScore: footballMatchLeftTeamScore });
    } else if (side == "right") {
      let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
      footballMatchRightTeamScore["event_time"] = e.target.value;
      this.setState({ footballMatchRightTeamScore: footballMatchRightTeamScore });
    }
  }

  updateFootballScore(side) {
    let eventObj =
      side == "left"
        ? this.state.footballMatchLeftTeamScore
        : this.state.footballMatchRightTeamScore;
    const url = `${getLocationOrigin()}/tournament/update_football_match_event/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ match_event: eventObj });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        let fixtures = JSON.parse(JSON.stringify(this.state.fixtures));
        let current_fixtures = JSON.parse(JSON.stringify(this.state.eventActionMatch));
        current_fixtures.team1_scores[0] = parseInt(data.team1_scores);
        current_fixtures.team2_scores[0] = parseInt(data.team2_scores);
        current_fixtures.match_events = data.match_events;
        current_fixtures["have_changes"] = true;
        fixtures[this.state.selected_indexes["grp"]].group_round_robin[
          this.state.selected_indexes["round"]
        ].matches[this.state.selected_indexes["match"]] = current_fixtures;
        this.setState({ eventActionMatch: current_fixtures, fixtures: fixtures });
      })
      .catch((error) => error);
  }

  handleEvent(event, dir) {
    this.setState(
      { selectedEvent: event, openPlayerList: true, teamSide: dir },
      () => {
        if (dir == "left") {
          let footballMatchLeftTeamScore = Object.assign({}, this.state.footballMatchLeftTeamScore);
          footballMatchLeftTeamScore["team_id"] = this.state.eventActionMatch.team_one.id;
          footballMatchLeftTeamScore["player_id"] = "";
          footballMatchLeftTeamScore["event"] = this.state.selectedEvent.id;
          footballMatchLeftTeamScore["side"] = "left";
          this.setState({ footballMatchLeftTeamScore: footballMatchLeftTeamScore });
        }
        if (dir == "right") {
          let footballMatchRightTeamScore = Object.assign({}, this.state.footballMatchRightTeamScore);
          footballMatchRightTeamScore["player_id"] = "";
          footballMatchRightTeamScore["team_id"] = this.state.eventActionMatch.team_two.id;
          footballMatchRightTeamScore["event"] = this.state.selectedEvent.id;
          footballMatchRightTeamScore["side"] = "right";
          this.setState({ footballMatchRightTeamScore: footballMatchRightTeamScore });
        }
      },
    );
  }

  computeLocalLeaderBoard() {
    var fixtures = this.state.fixtures;
    var groups = this.state.groups || [];

    return fixtures.map(function (groupData, grpIdx) {
      var groupName = groups[grpIdx] || groupData.group || ('Group ' + (grpIdx + 1));
      var teams = {};

      (groupData.group_round_robin || []).forEach(function (round) {
        (round.matches || []).forEach(function (match) {
          if (!match.id) return;
          var t1 = match.team_one;
          var t2 = match.team_two;
          if (!t1 || !t2 || !t1.id || !t2.id) return;
          if (t1.name === 'BYE' || t2.name === 'BYE') return;

          var s1raw = match.team1_scores && match.team1_scores[0];
          var s2raw = match.team2_scores && match.team2_scores[0];
          if (s1raw === undefined || s1raw === null || s1raw === '' ||
            s2raw === undefined || s2raw === null || s2raw === '') return;

          var s1 = Number(s1raw);
          var s2 = Number(s2raw);
          var k1 = String(t1.id);
          var k2 = String(t2.id);

          if (!teams[k1]) teams[k1] = { id: t1.id, team_id: t1.id, name: t1.name, matches_played: 0, won: 0, draw: 0, lose: 0, 'for': 0, against: 0, difference: 0, points: 0 };
          if (!teams[k2]) teams[k2] = { id: t2.id, team_id: t2.id, name: t2.name, matches_played: 0, won: 0, draw: 0, lose: 0, 'for': 0, against: 0, difference: 0, points: 0 };

          teams[k1].matches_played++;
          teams[k2].matches_played++;
          teams[k1]['for'] += s1; teams[k1].against += s2;
          teams[k2]['for'] += s2; teams[k2].against += s1;
          teams[k1].difference = teams[k1]['for'] - teams[k1].against;
          teams[k2].difference = teams[k2]['for'] - teams[k2].against;

          var t1wins = t1.winner === true;
          var t2wins = t2.winner === true;

          if (!t1wins && !t2wins && s1 === s2) {
            teams[k1].draw++; teams[k2].draw++;
            teams[k1].points++; teams[k2].points++;
          } else if (t1wins) {
            teams[k1].won++; teams[k2].lose++;
            teams[k1].points += 3;
          } else if (t2wins) {
            teams[k2].won++; teams[k1].lose++;
            teams[k2].points += 3;
          } else if (s1 > s2) {
            teams[k1].won++; teams[k2].lose++;
            teams[k1].points += 3;
          } else if (s2 > s1) {
            teams[k2].won++; teams[k1].lose++;
            teams[k2].points += 3;
          } else {
            teams[k1].draw++; teams[k2].draw++;
            teams[k1].points++; teams[k2].points++;
          }
        });
      });

      var sorted = Object.values(teams).sort(function (a, b) {
        if (b.points !== a.points) return b.points - a.points;
        if (b.difference !== a.difference) return b.difference - a.difference;
        return b['for'] - a['for'];
      });

      return { group: groupName, group_leader_board_score: sorted };
    });
  }


  fetchLeaderBoard() {
    var leaderBoard = this.computeLocalLeaderBoard();
    var qualified = leaderBoard.reduce(function (acc, g) {
      if (g.group_leader_board_score[0]) acc.push(g.group_leader_board_score[0]);
      if (g.group_leader_board_score[1]) acc.push(g.group_leader_board_score[1]);
      return acc;
    }, []);
    this.setState({
      leader_board: leaderBoard,
      selected_rows: qualified,
      openLeaderBoarderPopup: true,
    });
  }

  fetchKnockoutBoard() {
    var leaderBoard = this.computeLocalLeaderBoard();
    this.setState({
      leader_board: leaderBoard,
      selected_rows: [],   // no pre-selection
      leaderboard_loading: false,
      openKnockLeaderBoardPopup: true,
    });
  }

  saveLeaderBoard() {
    if (this.state.knockout_matches_created == false) {
      var qualified_teams1 = this.state.leader_board.map((x) => x.group_leader_board_score[0]);
      var qualified_teams2 = this.state.leader_board.map((x) => x.group_leader_board_score[1]);
      var qualified_teams = [...qualified_teams1, ...qualified_teams2];
      this.setState({ selected_rows: qualified_teams });
    }
    const url = `${getLocationOrigin()}/tournament/save_leader_board_tournament/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      leader_board: this.state.leader_board,
      competition_id: this.state.competition_id,
    });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => { console.warn('[saveLeaderBoard] non-critical save failed:', error.message); })
      .then((data) => { if (data) console.log('[saveLeaderBoard]', data); });
  }

  renderActionButtons() {
    return (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        {this.state.chosen_format == 10 ||
          this.state.chosen_format == 30 ||
          this.state.chosen_format == 80 ||
          this.state.chosen_format == 60 ||
          this.state.chosen_format == 90 ? (
          <button style={btn.outline} onClick={() => this.fetchKnockoutBoard()} type="button">
            Leaderboard table
          </button>
        ) : (
          <button style={btn.outline} onClick={() => this.fetchLeaderBoard()} type="button">
            Leaderboard table
          </button>
        )}
        <button
          style={btn.primary}
          onClick={() => this.openCreateFixturesPopup()}
          type="button"
        >
          Generate Fixtures
        </button>
        {this.state.fixtures.length > 0 && (
          <button
            disabled={this.state.submit_button_pressed}
            style={btn.danger}
            onClick={() => this.deleteFixtures()}
            type="button"
          >
            Delete fixtures
          </button>
        )}
      </div>
    );
  }

  renderGroupsList() {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 20 }}>
          {this.state.groups &&
            this.state.groups.map((group, idx) => (
              <button
                key={idx}
                type="button"
                style={{
                  padding: "6px 18px",
                  border: `2px solid ${this.state.selected_group == idx ? colors.brand : colors.border}`,
                  borderRadius: 20,
                  background: this.state.selected_group == idx ? colors.brand : colors.surface,
                  color: this.state.selected_group == idx ? "#fff" : colors.text,
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: "pointer",
                  fontFamily: "inherit",
                  transition: "all 0.15s",
                }}
                onClick={() => this.setState({ selected_group: idx })}
              >
                {group}
              </button>
            ))}
          {this.state.knockout_matches_created == true && (
            <Link to={`/crud/knockout-matches/${this.state.competition_id},fixture`}>
              <button
                type="button"
                style={{
                  padding: "6px 18px",
                  border: `2px solid ${colors.success}`,
                  borderRadius: 20,
                  background: colors.success,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 13,
                  cursor: "pointer",
                  fontFamily: "inherit",
                }}
              >
                View knockout matches
              </button>
            </Link>
          )}
        </div>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "var(--color-background-secondary, #f8fafc)",
          border: "0.5px solid #e2e8f0",
          borderRadius: 10, padding: "6px 14px",
        }}>
          <span style={{ fontSize: 13, color: "#64748b" }}>Total matches</span>
          <span style={{
            fontSize: 15, fontWeight: 600, color: "#1e293b",
            background: "#fff", border: "0.5px solid #cbd5e1",
            borderRadius: 6, padding: "2px 10px", minWidth: 24, textAlign: "center",
          }}>
            {this.state.fixtures.reduce((total, grp) =>
              total + grp.group_round_robin.reduce((rTotal, round) =>
                rTotal + (round.matches ? round.matches.length : 0), 0
              ), 0
            )}
          </span>
        </div>
      </div>
    );
  }

  renderFixtures() {
    return (
      <div style={{ padding: "0 0 24px" }}>
        <a
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            cursor: "pointer",
            color: colors.brand,
          }}
          onClick={() => this.props.history.goBack()}
        >
          <IconArrowLeft /> Back
        </a>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            marginBottom: 20,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: 20, fontWeight: 700, color: colors.text }}>
              Fixtures
            </span>
          </div>
          {this.renderActionButtons()}
        </div>

        {this.renderGroupsList()}

        {this.state.fixtures.length > 0 &&
          this.state.fixtures[this.state.selected_group].group_round_robin.map(
            (round, index) => {
              if (!round._isNew && (!round.matches || round.matches.length === 0)) {
                return null;
              }
              return (
                <FixtureRound
                  key={index}
                  round={round}
                  roundIndex={index}
                  grp={this.state.selected_group}
                  fixtures={this.state.fixtures}
                  team_list={this.state.team_list}
                  groups={this.state.groups}
                  venues={this.state.venues}
                  courts={this.state.courts}
                  competition_game={this.state.competition_game}
                  knockout_matches_created={this.state.knockout_matches_created}
                  getMatchHighlight={getMatchHighlight}
                  onHandleTeamChange={this.handleTeamChange.bind(this)}
                  onHandleFixtureCourt={this.handleFixtureCourt.bind(this)}
                  onHandleDateTimePicker={this.handleDateTimePicker.bind(this)}
                  onOpenPopup={this.openPopup.bind(this)}
                  onSaveNewMatch={this.saveNewMatch.bind(this)}
                  onRemoveUnsavedMatch={this.removeUnsavedMatch.bind(this)}
                  onSaveNewRound={this.saveNewRound.bind(this)}
                  onRemoveUnsavedRound={this.removeUnsavedRound.bind(this)}
                  onAddMatch={this.addMatch.bind(this)}
                  onUpdateMatch={this.updateMatch.bind(this)}
                  onSaveScore={this.saveMatchScore.bind(this)}
                  onAddCourt={this.handleAddCourt}
                />
              );
            },
          )}

        <div
          style={{
            color: colors.brand,
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            marginTop: 8,
            marginBottom: 28,
          }}
          onClick={(e) => this.addRound(e, this.state.selected_group)}
        >
          Add New Round +
        </div>

        {/* ── Legend ── */}
        <div
          style={{
            background: colors.surface,
            border: `1px solid ${colors.border}`,
            borderRadius: 10,
            padding: "18px 22px",
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 700, color: colors.text, marginBottom: 14 }}>
            Legend
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "center" }}>
            {[
              { bg: "#f0fdf4", border: "#22c55e", label: "Scored – Winner decided" },
              { bg: "#eff6ff", border: "#3b82f6", label: "Scored – Draw" },
              { bg: "#fff7ed", border: "#f59e0b", label: "Past match – Needs scoring" },
              { bg: "#f8fafc", border: "#cbd5e1", label: "Upcoming / Unscored" },
            ].map(({ bg, border, label }) => (
              <div key={label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div
                  style={{
                    width: 28,
                    height: 28,
                    border: `2px solid ${border}`,
                    borderRadius: 6,
                    background: bg,
                  }}
                />
                <span style={{ fontSize: 13, color: colors.text }}>{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Popups ── */}
        {this.state.openLeaderBoarderPopup && (
          <LeaderBoardPopup
            leader_board={this.state.leader_board}
            competition_game={this.state.competition_game}
            onClose={() => this.setState({ openLeaderBoarderPopup: false, leader_board: [] })}
          />
        )}
        {this.state.openKnockLeaderBoardPopup && (
          <KnockoutLeaderBoardPopup
            leader_board={this.state.leader_board}
            competition_game={this.state.competition_game}
            knockout_matches_created={this.state.knockout_matches_created}
            zones={this.state.zones}
            selected_zone={this.state.selected_zone}
            leaderboard_loading={this.state.leaderboard_loading}
            selected_rows={this.state.selected_rows}
            cup_shield_bowl_type={this.state.cup_shield_bowl_type}
            onClose={() => this.setState({ openKnockLeaderBoardPopup: false })}
            onHandleKnockout={this.handleKnockout.bind(this)}
            onZoneChange={(val) => this.setState({ selected_zone: val })}
            onClickCreate={this.onClickCreate}
            onCupShieldBowlTypeChange={(val) => this.setState({ cup_shield_bowl_type: val })}
            onClickCreateCupShieldBowl={this.createCupShieldBowlTournament}
          />
        )}

        <ScoreBoardMobile
          isOpen={this.state.openScoreBoard}
          eventActionMatch={this.state.eventActionMatch}
          team_list={this.state.team_list}
          game_events={this.state.game_events}
          footballMatchLeftTeamScore={this.state.footballMatchLeftTeamScore}
          footballMatchRightTeamScore={this.state.footballMatchRightTeamScore}
          leftOpen={this.state.leftOpen}
          rightOpen={this.state.rightOpen}
          submit_button_pressed={this.state.submit_button_pressed}
          onClose={() => this.setState({ openScoreBoard: false })}
          onHandleModel={this.handleModel.bind(this)}
          onChangePlayer={this.handleChangePlayer.bind(this)}
          onChangeEventTime={this.changeEventTime.bind(this)}
          onUpdateFootballScore={(side) => {
            this.setState({ selectedEvent: "" }, () => {
              this.updateFootballScore(side);
            });
          }}
          onDeleteEventHistory={this.deleteEventHistory.bind(this)}
          onSaveZeroZero={this.saveZeroZero.bind(this)}
          createImageFromInitials={this.createImageFromInitials}
          getRandomColor={this.getRandomColor}
        />

        <ScoreBoardDesktop
          isOpen={this.state.openScoreBoard}
          eventActionMatch={this.state.eventActionMatch}
          team_list={this.state.team_list}
          game_events={this.state.game_events}
          footballMatchLeftTeamScore={this.state.footballMatchLeftTeamScore}
          footballMatchRightTeamScore={this.state.footballMatchRightTeamScore}
          selectedEvent={this.state.selectedEvent}
          leftOpen={this.state.leftOpen}
          rightOpen={this.state.rightOpen}
          knockout_matches_created={this.state.knockout_matches_created}
          submit_button_pressed={this.state.submit_button_pressed}
          onClose={() => this.setState({ openScoreBoard: false })}
          onHandleEvent={this.handleEvent.bind(this)}
          onToggleOpen={(dir, leftOpen, rightOpen) => {
            this.setState({
              leftOpen: dir == "left" ? !leftOpen : leftOpen,
              rightOpen: dir == "right" ? !rightOpen : rightOpen,
            });
          }}
          onChangePlayer={this.handleChangePlayer.bind(this)}
          onChangeEventTime={this.changeEventTime.bind(this)}
          onUpdateFootballScore={(side) => {
            this.setState({ selectedEvent: "" }, () => {
              this.updateFootballScore(side);
            });
          }}
          onDeleteEventHistory={this.deleteEventHistory.bind(this)}
          onSaveZeroZero={this.saveZeroZero.bind(this)}
          createImageFromInitials={this.createImageFromInitials}
          getRandomColor={this.getRandomColor}
        />
      </div>
    );
  }

  renderSpinner() {
    return (
      <div style={spinnerStyle.wrap}>
        <Spinner name="line-scale-pulse-out-rapid" color={spinnerStyle.color} />
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
          padding: "16px 20px",
        }}
      >
        {this.state.is_loading == false ? (
          <div>
            {this.state.openKnockoutFixturesPopup || this.state.openCreateFixturesPopup ? (
              <div>
                {this.state.openCreateFixturesPopup && (
                  <CreateFixtureForm
                    match_details={this.state.match_details}
                    tournament_data={this.state.tournament_data}
                    team_count={this.state.team_count}
                    buddies={this.state.buddies}
                    search={this.state.search}
                    buddy_search_list={this.state.buddy_search_list}
                    submit_button_pressed={this.state.submit_button_pressed}
                    onClose={() => this.setState({ openCreateFixturesPopup: false })}
                    onHandleChange={this.handleChange}
                    onStartTimeChange={this.onStartTimeChange.bind(this)}
                    onSearchBuddy={this.searchBuddy}
                    onSetSearch={this.setSearch.bind(this)}
                    onHandleRequestDelete={this.handleRequestDelete}
                    onSubmit={this.handleSubmit}
                  />
                )}
              </div>
            ) : (
              <div>{this.renderFixtures()}</div>
            )}
          </div>
        ) : (
          this.renderSpinner()
        )}
      </div>
    );
  }
}

export default viewFixtureScreen;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureScreen/index.js